import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeFr from '../views/HomeFr.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/mt4-trading-platform'
  },
  {
    path: '/mt4-trading-platform',
    name: 'home',
    component: Home,
    children: [
      {
        path: 'fr',
        name: 'homefr',
        component: HomeFr
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
